import React from "react";
import "./ManagePartners.css";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../../assests/leftArrow.svg";
import { useNavigate } from "react-router-dom";
import Table from "react-bootstrap/Table";
import refillEye from "../../../../assests/refillEye.svg";
import search from "../../../../assests/search.svg";
import emotions7 from "../../../../assests/emotions7.svg";
import Button from "@mui/material/Button";
import LoadingSpinner from "../../../Loading/component";

const ManagePartnersComponent = (props) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/");
  };

  const managePartnerDetails = (franchiseeId, cohortId) => {
    navigate(
      `/home/configuration/managepartnersdetails/${franchiseeId}/${cohortId}/${franchiseeId}`
    );
  };

  return (
    <>
      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="main-div">
          <Sidebar />
          
          <div className="partners-container">
            <div className="page-header">
              <h2>
                <img 
                  onClick={handleClick}
                  className="back-arrow" 
                  src={leftArrow} 
                  alt="Back" 
                />
                Manage Partners
              </h2>
            </div>

            <div className="search-add-container">
              <div className="input-container-partner">
                <input
                  type="search"
                  className="search-input"
                  placeholder="Search by Owner ID / Cohort ID"
                  value={props.searchValue}
                  onChange={props.handleSearchInputChange}
                />
                {/* <button
                  className="search-icon"
                  onClick={props.handleFilterFranchisees}
                >
                  <img src={search} alt="Search" />
                </button> */}
              </div>

              <Button
                variant="contained"
                color="primary"
                className="add-button"
                onClick={props.handleAddNewEntery}
              >
                + Add New
              </Button>
            </div>

            <div className="manage-partner-list">
              <div className="partner-table-container">
                <Table className="partner-table" striped hover>
                  <thead>
                    <tr>
                      <th style={{ width: '10%' }}>ID</th>
                      <th style={{ width: '15%' }}>Name</th>
                      <th style={{ width: '25%' }}>Description</th>
                      <th style={{ width: '10%' }}>Type</th>
                      <th style={{ width: '15%' }}>Cohort ID</th>
                      <th style={{ width: '15%' }}>Owner ID</th>
                      <th style={{ width: '10%' }}>Actions</th>
                    </tr>
                  </thead>
                </Table>
                <div className="table-scroll" ref={props.tableContainerRef}>
                  <Table className="partner-table">
                    <tbody>
                      {props.filteredFranchiseeList?.length > 0 ? (
                        props.filteredFranchiseeList.map((item) => (
                          <tr key={item.id}  className="partner-table-row"  onClick={() => managePartnerDetails(item.id, item.cohortId)}>
                            <td style={{ width: '10%' }}>{item.id}</td>
                            <td style={{ width: '15%' }}>{item.name}</td>
                            <td style={{ width: '25%' }}>{item.description}</td>
                            <td style={{ width: '10%' }}>{item.type}</td>
                            <td style={{ width: '15%' }}>{item.cohortId}</td>
                            <td style={{ width: '15%' }}>{item.ownerId}</td>
                            <td style={{ width: '10%' }}>
                              <img
                                className="partner-eye-icon" 
                                onClick={() => managePartnerDetails(item.id, item.cohortId)}
                                src={refillEye}
                                alt="View Details"
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7">
                            <div className="no-partner-found">
                              <img
                                className="no-order-img"
                                src={emotions7}
                                alt="No partners found"
                              />
                              <p className="no-order-para">No Partner Found</p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ManagePartnersComponent;